// src/hooks/transportations/useDeleteAllTransportations.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllTransportations } from "../../api/apiTransportations";
import parseError from "../../utils/parseError";

const useDeleteAllTransportations = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllTransportationsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: deleteAllTransportations,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["transportations"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete transportations");
        },
    });

    return {
        deleteAllTransportations: deleteAllTransportationsMutate,
        isDeleteAll: isPending || isLoading,
    };
};

export default useDeleteAllTransportations;
